'use client';

import { CacheProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { useState } from 'react';

import { PageTitleContext } from 'reservations/account/providers/PageTitleProvider';
import { useRouterNav } from 'reservations/base/hooks/useRouterNav';
import ReservationsProvider from 'reservations/base/providers/ReservationsProvider';
import { RouterProvider } from 'reservations/base/providers/RouterProvider';
import createEmotionCache from 'utility/createEmotionCache';

const clientSideEmotionCache = createEmotionCache();

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { handleNavigation, handleOffRouteChange, handleOnRouteChange } =
    useRouterNav();

  const [faviconUrl, setFaviconUrl] = useState('');

  return (
    <html lang="en">
      <head>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        {faviconUrl && (
          <link
            rel="icon"
            href={faviconUrl}
            type="image/<generated>"
            sizes="<generated>"
          />
        )}
      </head>
      <body>
        <CacheProvider value={clientSideEmotionCache}>
          <RouterProvider
            handleNavigation={handleNavigation}
            handleOffRouteChange={handleOffRouteChange}
            handleOnRouteChange={handleOnRouteChange}
          >
            <PageTitleContext.Provider value={{ setFaviconUrl }}>
              <ReservationsProvider>
                <Grid
                  container
                  direction="column"
                  wrap="nowrap"
                  sx={{ height: '100vh' }}
                >
                  <Grid item xs={11}>
                    {children}
                  </Grid>
                </Grid>
              </ReservationsProvider>
            </PageTitleContext.Provider>
          </RouterProvider>
        </CacheProvider>
      </body>
    </html>
  );
};
